<template>
    <b-container>
        <b-row>
            <b-col cols="auto">
                <b-btn size="sm" variant="primary" @click="$router.go(-1)"
                    ><i class="fa fa-arrow-left" aria-hidden="true"></i
                ></b-btn>
            </b-col>
            <b-col>
                <app-sub-title
                    :text="`${processName} > ${typeName}`"
                ></app-sub-title>
            </b-col>
        </b-row>
        <b-row v-if="userCan('upload-quality-document')">
            <b-col>
                <b-btn
                    size="sm"
                    variant="primary"
                    @click="openModal('document-form-modal')"
                    ><i class="fa fa-plus"></i> Subir Documento</b-btn
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col> {{ documents.length }} documentos </b-col>
        </b-row>
        <b-row>
            <b-col
                cols="12"
                md="6"
                v-for="document in documents"
                :key="document.id"
                class="mb-2"
            >
                <app-file-card
                    :file="document"
                    @delete="onDeleteDocument"
                ></app-file-card>
            </b-col>
        </b-row>
        <b-modal
            id="document-form-modal"
            ref="document-form-modal"
            title="Formulario para subir archivo"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok.prevent="onUploadDocument"
            no-close-on-backdrop
            no-close-on-esc
        >
            <app-document-form
                @save="onSaveDocument"
                ref="document-form"
            ></app-document-form>
        </b-modal>
    </b-container>
</template>
<script>
import appFileCard from './FileCard'
import appDocumentForm from './DocumentForm'
export default {
    components: {
        appFileCard,
        appDocumentForm,
    },
    data: () => ({
        documents: [],
        processId: '',
        processName: '',
        typeId: '',
        typeName: '',
    }),
    computed: {},
    methods: {
        validateParameters() {
            if (!('p' in this.$route.query))
                return this.$router.push({ name: 'quality' })

            const payload = JSON.parse(atob(this.$route.query.p))

            this.processId = payload.processId
            this.processName = payload.processName
            this.typeId = payload.typeId
            this.typeName = payload.typeName
        },
        async loadDocuments() {
            const { data } = await repo.get('quality/documents', {
                processId: this.processId,
                typeId: this.typeId,
            })

            this.documents = data
        },
        onUploadDocument() {
            this.$refs['document-form'].save()
        },
        async onSaveDocument(document) {
            const formData = new FormData()
            _.forIn(document, (val, key) => formData.append(key, val))
            formData.append('processId', this.processId)
            formData.append('typeId', this.typeId)

            const { data } = await repo.post('quality/documents', formData)

            if (data.status) {
                this.closeModal('document-form-modal')
                this.documents.push(data.result)
                return toastr.success('Archivo subido satisfactoriamente')
            }

            return toastr.error(data.msg)
        },
        async onDeleteDocument(doc) {
            try {
                const { data } = await repo.delete(
                    `quality/documents/${doc.id}`
                )
                const documents = this.documents.filter(
                    item => item.id !== doc.id
                )
                this.documents = documents
            } catch (error) {
                return toastr.error('Ocurrió un error al eliminar el documento')
            }
        },
    },
    created() {
        this.validateParameters()
        this.loadDocuments()
    },
}
</script>
